import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const PushSendSkip = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M14.25 15.75V20.518C14.25 20.8769 14.1793 21.2322 14.0419 21.5637C13.9046 21.8952 13.7033 22.1965 13.4495 22.4502C13.1957 22.7039 12.8944 22.9051 12.5628 23.0423C12.2312 23.1796 11.8759 23.2501 11.517 23.25H4.983C4.62414 23.2501 4.26878 23.1796 3.9372 23.0423C3.60562 22.9051 3.30433 22.7039 3.05054 22.4502C2.79674 22.1965 2.59542 21.8952 2.45806 21.5637C2.3207 21.2322 2.25 20.8769 2.25 20.518V4.983C2.25 4.25816 2.53794 3.56301 3.05048 3.05048C3.56301 2.53794 4.25816 2.25 4.983 2.25H6.75"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.25 18.75H14.25"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 6.75C9.75 8.3413 10.3821 9.86742 11.5074 10.9926C12.6326 12.1179 14.1587 12.75 15.75 12.75C17.3413 12.75 18.8674 12.1179 19.9926 10.9926C21.1179 9.86742 21.75 8.3413 21.75 6.75C21.75 5.1587 21.1179 3.63258 19.9926 2.50736C18.8674 1.38214 17.3413 0.75 15.75 0.75C14.1587 0.75 12.6326 1.38214 11.5074 2.50736C10.3821 3.63258 9.75 5.1587 9.75 6.75V6.75Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1658 4.3335L13.6658 8.83349"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6658 4.3335L18.1658 8.83349"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
